import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=631e4db7&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=ts"
export * from "./transfer.vue?vue&type=script&lang=ts"
import style0 from "./transfer.vue?vue&type=style&index=0&id=631e4db7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e4db7",
  null
  
)

export default component.exports